import {ReactNode} from 'react';

import ProductModel from 'coreClasses/product/ProductModel';
import VariantModel from 'coreClasses/product/VariantModel';
import ProductSearchHitModel from 'coreClasses/search/ProductSearchHitModel';

import {ICarouselProps} from 'brandComponents/Carousel';
import {IPictureProps} from 'brandComponents/Picture/IPicture';
import {PRODUCT_IMAGES_SETTINGS} from 'brand/app/constants';

export enum EProductMediaType {
	PICTURE = 'PICTURE',
	CAROUSEL = 'CAROUSEL',
}

export interface IProductMediaProps {
	mediaType: EProductMediaType;
	product: ProductModel | VariantModel | ProductSearchHitModel;
	onClick?: () => void;
	carouselConfig?: Partial<ICarouselProps['config']>;
	classNames?: string;
	ratio?: number | null;
	imageSettings?: typeof PRODUCT_IMAGES_SETTINGS[keyof typeof PRODUCT_IMAGES_SETTINGS];
	isLink?: boolean
	renderPicture?: (data?: any) => ReactNode;
	showPlaceholder: boolean;
	/** `priority` of the tile image (the carousel slides are lazy). */
	priority?: IPictureProps['priority'];
}
